import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useSelector } from "react-redux"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { MENU_GROUPS, getUserRoutes } from "routes/allRoutes"
import { getFormattedRoutesList, getMenuGroupData } from "utils"
import { URL_PATHS } from "constants/index"

const SidebarContent = props => {
  const ref = useRef()
  const clientConfigNew = useSelector(state => state.Login.clientConfig)
  const featuresAvailable = useSelector(state => state.Login.featuresAvailable)

  const formattedRoutes = useMemo(() => {
    if (!clientConfigNew) return []

    return getFormattedRoutesList(
      getUserRoutes(clientConfigNew, featuresAvailable)
    )
  }, [clientConfigNew, featuresAvailable])

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%", width: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Menu</li>

            {!!formattedRoutes &&
              formattedRoutes?.map((route, index) => {
                if (route.isMenuGroup) {
                  let menu = getMenuGroupData(route)
                  if (menu.routes && menu.routes.length > 0) {
                    return (
                      <li key={index}>
                        <Link to="/#" className="has-arrow waves-effect">
                          <i className={MENU_GROUPS[menu.key].icon}></i>
                          <span>{MENU_GROUPS[menu.key].display}</span>
                        </Link>
                        <ul className="sub-menu" aria-expanded="false">
                          {menu.routes.map((menuRoute, index) => (
                            <li key={index}>
                              <Link to={menuRoute.path}>
                                {menuRoute.display}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )
                  }
                } else if (!route.showOnBottom) {
                  return (
                    <li key={index}>
                      <Link to={route.path} className="waves-effect">
                        <i className={route.icon}></i>
                        <span>{route.display}</span>
                      </Link>
                    </li>
                  )
                }
              })}
          </ul>
        </div>
      </SimpleBar>
      <SimpleBar style={{ maxHeight: "100%", width: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {!!formattedRoutes &&
              formattedRoutes?.map((route, index) => {
                if (route.showOnBottom) {
                  return (
                    <li key={index}>
                      <Link to={route.path} className="waves-effect">
                        <i className={route.icon}></i>
                        <span>{route.display}</span>
                      </Link>
                    </li>
                  )
                }
              })}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(SidebarContent)
